import React, {useMemo, useState} from "react";
import ReportingNav from "../../nav/ReportingNav";
import BasicReporting from "./reportingPages/BasicReporting";
import Explore from "./reportingPages/Explore";
import Discover from "./reportingPages/Discover";

const Reporting = () => {
    const [active, setActive] = useState('basic');

    const renderPage = useMemo(() => {
        switch (active) {
            case 'basic':
                return <BasicReporting />;
            case 'explore':
                return <Explore />;
            case 'discover':
                return <Discover />;
            default:
                break; //do nothing
        }
    }, [active]);

    return useMemo(() =>{
        return (
            <div className="main-content">
                <h2>Reporting</h2>
                <ReportingNav appearance="tabs" active={active} onSelect={setActive} />
                {renderPage}
            </div>
        );
    }, [active, renderPage]);
};

export default Reporting;